import { render, staticRenderFns } from "./Serialized-Inventory.vue?vue&type=template&id=56602b9d"
import script from "./Serialized-Inventory.vue?vue&type=script&lang=js"
export * from "./Serialized-Inventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports